<template>
  <div class="w-full mx-auto h-full flex flex-col justify-center items-center">
    <div class="w-full max-w-md border border-gray-300 p-4">
      <div class="p-4 m-4 w-full flex flex-col items-center justify-center">
        <img src="@/assets/logo.png" alt="logo" class="w-18 h-18 mr-4">
        <span class="my-4 mx-2 text-2xl font-semibold">Recuperar contraseña</span>
      </div>
      <p class="text-sm text-gray-600 mb-4 px-1">
        Ingresá el correo de tu cuenta. Si está registrado, recibirás un enlace para restablecer la contraseña.
      </p>
      <template v-if="!submitted">
        <div class="w-full flex justify-start">Email</div>
        <input
          v-model="email"
          type="email"
          placeholder="Email"
          class="w-full my-2 p-1 border border-gray-200 rounded-md"
          :disabled="isLoading"
          autocomplete="email"
        >
        <div class="text-red-400 text-sm" v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <button
          v-if="!isLoading"
          type="button"
          class="w-full my-2 px-4 py-2 text-gray-200 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700"
          @click="submit"
        >
          Enviar instrucciones
        </button>
        <div v-else class="flex items-center justify-center my-2">
          <span class="h-6 w-6 animate-spin border-2 border-t-blue-500 border-transparent rounded-full" />
        </div>
      </template>
      <div v-else class="text-gray-700 text-sm">
        {{ successMessage }}
      </div>
      <router-link
        :to="{ name: 'login' }"
        class="block mt-4 text-sm text-gray-600 hover:text-gray-900 underline"
      >
        Volver al inicio de sesión
      </router-link>
    </div>
  </div>
</template>

<script>
import { forgotPassword } from '@/service/auth.service'

export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      email: '',
      isLoading: false,
      submitted: false,
      successMessage: '',
      errorMessage: null,
    }
  },
  methods: {
    async submit() {
      this.errorMessage = null
      const trimmed = (this.email || '').trim()
      if (!trimmed) {
        this.errorMessage = 'Ingresá un correo electrónico.'
        return
      }
      this.isLoading = true
      try {
        const { data } = await forgotPassword({ email: trimmed })
        this.successMessage =
          data?.message ||
          'Si el correo está registrado, recibirás instrucciones para restablecer la contraseña.'
        this.submitted = true
      } catch (error) {
        const msg = error.response?.data?.message
        this.errorMessage =
          msg || 'No se pudo completar la solicitud. Intentá de nuevo más tarde.'
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
